import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRevueComponent } from './simple-icons-revue.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRevueComponent ],
    exports:      [ SimpleIconsRevueComponent ],
    bootstrap:    []
})
export class SimpleIconsRevueModule {}
